import {combineReducers} from "@reduxjs/toolkit";
import account from "./slices/account";
import stake from "./slices/stake";

const rootReducer = combineReducers({
    account: account,
    stake: stake
})

export { rootReducer }